import { render, staticRenderFns } from "./screenButton.vue?vue&type=template&id=23466ea2&"
import script from "./screenButton.vue?vue&type=script&lang=js&"
export * from "./screenButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports